<template>
  <div>
    <select
      v-model="selectedRangeType"
      class="form-control"
      @change="
        event => {
          dateRangeChanged(event.target.value);
        }
      "
    >
      <option v-for="(option, value) in rangeTypeOptions" :key="value" :value="value">{{ option }}</option>
    </select>
    <div v-if="selectedRangeType === 'custom'">
      From:
      <datepicker
        v-model="fromPickedDate"
        format="MM/dd/yyyy"
        input-class="form-control form-control-sm"
        @input="dateRangeChanged('custom')"
      ></datepicker
      >To:
      <datepicker
        v-model="toPickedDate"
        format="MM/dd/yyyy"
        input-class="form-control form-control-sm"
        @input="dateRangeChanged('custom')"
      ></datepicker>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
// import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
// import * as lang from 'vuejs-datepicker/src/locale'
export default {
  name: 'DateRangePicker',
  props: {
    value: {
      type: Object,
      required: true,
      validator: value => {
        if (value.from === null && value.to === null) {
          return true;
        }
        return true; // 'from' in value && value.hasOwnProperty('from') && 'to' in value && value.hasOwnProperty('to') && typeof value.from === 'Date' && typeof value.to === 'Date'
      },
    },
  },
  data() {
    return {
      rangeTypeOptions: {
        yesterday: 'Yesterday',
        today: 'Today',
        thisweek: 'This Week',
        lastweek: 'Last Week',
        thismonth: 'This Month',
        lastmonth: 'Last Month',
        last3months: 'Last 3 Months',
        last6months: 'Last 6 Months',
        custom: 'Custom Range...',
      },
      selectedRangeType: null,
      fromPickedDate: null,
      toPickedDate: null,
    };
  },
  watch: {
    value: function (newValue) {
      this.updateComponentWithValue(newValue);
    },
  },
  mounted() {
    this.updateComponentWithValue(this.value);
  },
  methods: {
    calculateRangeForType(rangeType) {
      switch (rangeType) {
        case 'yesterday':
          return {
            from: moment().subtract(1, 'day').startOf('day').toDate(),
            to: moment().subtract(1, 'day').endOf('day').toDate(),
          };

        case 'today':
          return {
            from: moment().startOf('day').toDate(),
            to: moment().endOf('day').toDate(),
          };

        case 'thisweek':
          return {
            from: moment().startOf('week').toDate(),
            to: moment().endOf('week').toDate(),
          };

        case 'lastweek':
          return {
            from: moment().subtract(1, 'week').startOf('week').toDate(),
            to: moment().subtract(1, 'week').endOf('week').toDate(),
          };

        case 'thismonth':
          return {
            from: moment().startOf('month').toDate(),
            to: moment().endOf('month').toDate(),
          };

        case 'lastmonth':
          return {
            from: moment().subtract(1, 'month').startOf('month').toDate(),
            to: moment().subtract(1, 'month').endOf('month').toDate(),
          };

        case 'last3months':
          return {
            from: moment().subtract(3, 'month').startOf('month').toDate(),
            to: moment().endOf('month').toDate(),
          };

        case 'last6months':
          return {
            from: moment().subtract(6, 'month').startOf('month').toDate(),
            to: moment().endOf('month').toDate(),
          };

        default:
          return null;
      }
    },
    dateRangeChanged(rangeType) {
      if (this.selectedRangeType === 'custom') {
        if (this.fromPickedDate === null || this.toPickedDate === null) {
          // return
        } else {
          let dateRange = {
            from: moment(this.fromPickedDate).startOf('day').toDate(),
            to: moment(this.toPickedDate).endOf('day').toDate(),
          };

          this.$emit('input', dateRange);
          // return
        }
      } else {
        let dateRange = this.calculateRangeForType(rangeType);
        this.$emit('input', dateRange);
      }
    },
    updateComponentWithValue(newValue) {
      if (newValue.from === null && newValue.to === null) {
        this.selectedRangeType = 'thisweek';
        let dateRange = this.calculateRangeForType(this.selectedRangeType);

        this.fromPickedDate = dateRange.from;
        this.toPickedDate = dateRange.to;

        this.$emit('input', dateRange);
      } else {
        // this.selectedRangeType = 'custom'
        this.fromPickedDate = newValue.from;
        this.toPickedDate = newValue.to;
      }
    },
  },
};
</script>
